import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Tab from "./Tab"
import './style.css'

class NRTTabContainer extends Component {


    state = {
        activeTabId: null
    }


    static getDerivedStateFromProps(nextProps) {
        return {
            activeTabId: nextProps.activeTabId || null
        }
    }


    setActiveTab(tabId) {
        this.setState({
            activeTabId: tabId
        })
    }


    tabClick = (tabId) => {
        if (this.props.handleTabChange)
            this.setActiveTab(tabId)

        this.props.onTabClick(tabId)
    }


    render() {

        const {
            tabs,
            mountAllTabs,
        } = this.props
        const {activeTabId} = this.state

        return (
            <div className='nrt-tab-container'>
                <div className={'tabs-container'}>
                    {
                        tabs.map(tab =>
                            tab &&
                            <Tab key={'aba' + tab.id}
                                 onClick={() => !tab.disabled ? this.tabClick(tab.id): null}
                                 active={activeTabId === tab.id}
                                 styles={{
                                     opacity: tab.disabled ? .4 : 1
                                 }}
                            >
                                {tab.label}
                            </Tab>
                        )
                    }
                </div>
                <div className={'tab-content'}>

                    {
                        tabs
                            .filter(
                                mountAllTabs ?
                                    () => true :
                                    tab => tab.id === activeTabId
                            )
                            .map(tab =>
                                tab &&
                                <div
                                    key={tab.id}
                                    style={{
                                        height: '100%',
                                        width: '100%',

                                        display: tab.id === activeTabId ? 'block' : 'none'
                                    }}>

                                    {tab.content}


                                </div>
                            )
                    }


                </div>
            </div>
        )
    }
}

NRTTabContainer.propTypes = {
    /** Id da tab ativa.*/
    activeTabId: PropTypes.string,
    /** Callback quando tab for clicada..*/
    onTabClick: PropTypes.func.isRequired,
    /** Definicao das tabs.*/
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.any.isRequired,
            content: PropTypes.any.isRequired,
        })
    ).isRequired,
    /** Altera as tabs automaticamente, senao deixa a cargo do componente pai.*/
    handleTabChange: PropTypes.bool,

    /** Monta todas as tabs independente de quem esta ativa .*/
    mountAllTabs: PropTypes.bool,
}

NRTTabContainer.defaultProps = {
    onTabClick: () => null,
    handleTabChange: true,
    mountAllTabs: false,

}

export default NRTTabContainer



// WEBPACK FOOTER //
// ./src/components/_common/TabContainer/index.js